// @ts-check

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Button from 'js/components/Button/Button'
import Flexer from 'js/components/Flexer/Flexer'
import FormItem from 'js/components/Form/FormItem'
import Spacer from 'js/components/Spacer/Spacer'
import { VIDEO_PLATFORM } from 'js/lib/constants'
import useInsertVideo from 'js/lib/hooks/useInsertVideo'

const InsertVideo = ({
    video,
    setVideo,
    videoTitle,
    setVideoTitle,
    onClose,
}) => {
    const { t } = useTranslation()

    const { videoValidationPattern, videoHelper } = useInsertVideo({
        disabledPlatforms: [VIDEO_PLATFORM.BlueBillywig], // TODO: Remove this once BlueBillywig is supported for cover videos
    })

    const defaultValues = {
        video,
        videoTitle,
    }

    const {
        control,
        handleSubmit,
        formState: { isValid },
    } = useForm({
        mode: 'onChange',
        defaultValues,
    })

    const handleOnSubmit = ({ video, videoTitle }, evt) => {
        evt.preventDefault()
        evt.stopPropagation()

        setVideo(video)
        setVideoTitle(videoTitle)
        onClose()
    }

    const handleOnError = (errors) => {
        console.error(errors)
    }

    const handleOnReset = () => {
        onClose()
    }

    return (
        <form
            onSubmit={handleSubmit(handleOnSubmit, handleOnError)}
            onReset={handleOnReset}
        >
            <Spacer>
                <FormItem
                    control={control}
                    type="text"
                    name="video"
                    label={t('form.url')}
                    id="video-url"
                    helper={videoHelper}
                    required
                    rules={{
                        pattern: {
                            value: videoValidationPattern,
                            message: t('error.invalid-video-url'),
                        },
                    }}
                />

                <FormItem
                    control={control}
                    type="text"
                    name="videoTitle"
                    label={t('editor.video-title')}
                    helper={t('editor.video-title-helper')}
                />

                <Flexer>
                    <Button size="normal" variant="tertiary" type="reset">
                        {t('action.cancel')}
                    </Button>
                    <Button
                        type="submit"
                        size="normal"
                        variant="primary"
                        disabled={!isValid}
                    >
                        {video ? t('action.save') : t('action.insert')}
                    </Button>
                </Flexer>
            </Spacer>
        </form>
    )
}

export default InsertVideo
